module.exports = __webpack_public_path__ + "img/icon-close.6cb7e9ff.svg";